import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Checkbox, Confirm, Form, Grid, Input, Modal, Panel } from 'framework-ui-components';

import { preferenzeStampa } from 'apis/setteTrentaApi';

const FORM_INITIAL_STATE = {
  SalvaPreferenze: true,
  IsStampaUfficiale: false,

  StampaDichiarazione: true,
  AutocertificazioneGenerica: false,
  FascicoloContribuente: false,

  AutocertificazioneFamiglieNumerose: false,
  DelegaUnica: false, // DelegaPrecompilatoCU AnnoImpostaPiuUno
  InformativaPrivacy: false,

  AutocertificazioneFamiliari: false,
  StampaF24: false,
  Scelta582x1000: false,

  AutocertificazioneC4: false,
  RichiestaAccredito: false,
  DocumentiDaConsegnare: false,

  AutocertificazioneOneri: false,
  PromemoriaConguagli: false,
  DelegaPrecompilatoCU: false, // DelegaPrecompilatoCU AnnoImposta

  AutocertificazioneF6: false,
  CalcoloBonusIRPEF: false,
  Fatture: false,
  LetteraNovita: false,

  RistampaLeStampate: false,
  NrCopie: 1,
  FronteRetro: true,
  ModelliCompilati: false,
  GuidaLettura: false,
  ArchiviaInZip: false,
  ImpostazioneStampa: 2,
  //MaxPaginePdf: 200,
};

class ModaleStampa extends Component {
  state = {
    ...FORM_INITIAL_STATE,
    stampaAbilitata: true,
    isLoadingInternal: false,
  }

  componentWillReceiveProps(nextProps) {
    const { showModal } = this.props;
    if (nextProps.showModal && showModal != nextProps.showModal) {
      this.caricaPreferenzeStampa(nextProps.userId);
    }
  }

  copieKeyDown = (evt) => {
    let copie = this.state.NrCopie;
    if (evt.keyCode == '38') {
      copie++;
    } else if (evt.keyCode == '40') {
      if (copie > 0) {
        copie--;
      }
    }
    this.setState({ NrCopie: copie });
  }

  annulla = () => {
    const { onAnnulla } = this.props;
    this.setState(FORM_INITIAL_STATE, () => onAnnulla && onAnnulla());
  }

  updateForm = (data) => {
    this.setState(data, () => {
      this.aggiornaStampaAbilitata();
    });
  }

  stampa = () => {
    const { NrCopie, RistampaLeStampate, StampaDichiarazione } = this.state;
    const { nrDichiarazioniSelezionate, nrDichiarazioniSelezionateNonStampate, nrDichiarazioniSelezionateStampate, onStampa } = this.props;
    let nPagine = NrCopie * nrDichiarazioniSelezionate * 20;
    if (RistampaLeStampate == false) {
      nPagine = NrCopie * nrDichiarazioniSelezionateNonStampate * 20;
    }
    if (NrCopie.FronteRetro == true) {
      nPagine *= 2;
    }
    if (RistampaLeStampate == false && StampaDichiarazione == true && nrDichiarazioniSelezionateStampate === nrDichiarazioniSelezionate) {
      Confirm('Dichiarazioni non stampabili', `Sono state scelte tutte dichiarazioni stampate senza l\'opzione Ristampa le già stampate.`, 'error').then(x => { });
    } else if (NrCopie > 5) {
      Confirm('Dichiarazioni non stampabili', `Non è possibile stampare più di 5 copie. Impostare il campo "Numero Copie" ad un valore pari a 5 o inferiore`, 'error').then(x => { });
    } /*else if (nPagine > FORM_INITIAL_STATE.MaxPaginePdf || nrDichiarazioniSelezionate > 20) {
      Confirm('Dichiarazioni non stampabili', `Le dichiarazioni scelte con le opzioni selezionate superano il limite massimo di pagine stampabili. Selezionare meno dichiarazioni o impostare un minor numero di copie.`, 'error').then(x => { });
    }*/ else {
      onStampa && onStampa(this.state);
    }
  }

  setCheckBoxState = (propName) => {
    this.setState({
      [propName]: !this.state[propName],
    }, () => this.aggiornaStampaAbilitata());
  }

  clickFascicoloContribuente = () => {
    const { FascicoloContribuente } = this.state;
    if (FascicoloContribuente == false) {
      this.setState({
        FascicoloContribuente: true,
        InformativaPrivacy: true,
        Scelta582x1000: true,
        DocumentiDaConsegnare: true,
        // DelegaPrecompilatoCU: true,
      }, () => this.aggiornaStampaAbilitata());
    } else {
      this.setState({
        FascicoloContribuente: false,
        InformativaPrivacy: false,
        Scelta582x1000: false,
        DocumentiDaConsegnare: false,
        // DelegaPrecompilatoCU: false,
      }, () => this.aggiornaStampaAbilitata());
    }
  }

  setCheckBoxState2 = (propName) => {
    const {
      InformativaPrivacy, Scelta582x1000, DocumentiDaConsegnare
    } = this.state;
    if ((!InformativaPrivacy || propName == 'InformativaPrivacy')
      && (!Scelta582x1000 || propName == 'Scelta582x1000')
      && (!DocumentiDaConsegnare || propName == 'DocumentiDaConsegnare')) {
      this.setState({
        FascicoloContribuente: false,
        InformativaPrivacy: false,
        Scelta582x1000: false,
        DocumentiDaConsegnare: false,
        // DelegaPrecompilatoCU: false,
      }, () => this.aggiornaStampaAbilitata());
    } else {
      this.setState({
        [propName]: !this.state[propName],
      }, () => this.aggiornaStampaAbilitata());
    }
  }

  aggiornaStampaAbilitata = () => {
    const {
      StampaDichiarazione,
      AutocertificazioneGenerica,
      FascicoloContribuente,
      AutocertificazioneFamiglieNumerose,
      DelegaUnica, // DelegaPrecompilatoCU AnnoImpostaPiuUno
      InformativaPrivacy,
      AutocertificazioneFamiliari,
      StampaF24,
      Scelta582x1000,
      AutocertificazioneC4,
      RichiestaAccredito,
      DocumentiDaConsegnare,
      AutocertificazioneOneri,
      PromemoriaConguagli,
      DelegaPrecompilatoCU, // DelegaPrecompilatoCU AnnoImposta
      AutocertificazioneF6,
      CalcoloBonusIRPEF,
      Fatture,
      LetteraNovita,
      NrCopie,
    } = this.state;

    const stAbilitata = (
      StampaDichiarazione
      || AutocertificazioneGenerica
      || FascicoloContribuente
      || AutocertificazioneFamiglieNumerose
      || DelegaUnica
      || InformativaPrivacy
      || AutocertificazioneFamiliari
      || StampaF24
      || Scelta582x1000
      || AutocertificazioneC4
      || RichiestaAccredito
      || DocumentiDaConsegnare
      || AutocertificazioneOneri
      || PromemoriaConguagli
      || DelegaPrecompilatoCU
      || AutocertificazioneF6
      || CalcoloBonusIRPEF
      || Fatture
      || LetteraNovita) && NrCopie && NrCopie > 0;

    this.setState({ stampaAbilitata: stAbilitata });
  }

  caricaPreferenzeStampa(userId) {
    const { annoSelezionato } = this.props;
    this.setState({ isLoadingInternal: true }, () => {
      preferenzeStampa(userId, annoSelezionato)
        .then((res) => {
          if (res) {
            this.setState({ ...res, isLoadingInternal: false });
            this.setState({ isLoadingInternal: false });
            /* if (res.StampaDichiarazione)
                 this.state(FORM_INITIAL_STATE.StampaProvaUfficiale, res.StampaDichiarazione);*/
          } else {
            this.setState({ ...FORM_INITIAL_STATE, isLoadingInternal: false });
          }
        });
    });
  }

  render() {
    const {
      showModal, stampaProva, messaggioErrore, isLoadingModale, tabTutte, annoSelezionato,
    } = this.props;
    const {
      StampaDichiarazione,
      AutocertificazioneGenerica,
      FascicoloContribuente,
      AutocertificazioneFamiglieNumerose,
      DelegaUnica, // DelegaPrecompilatoCU AnnoImpostaPiuUno
      InformativaPrivacy,
      AutocertificazioneFamiliari,
      StampaF24,
      Scelta582x1000,
      AutocertificazioneC4,
      RichiestaAccredito,
      DocumentiDaConsegnare,
      AutocertificazioneOneri,
      PromemoriaConguagli,
      DelegaPrecompilatoCU, // DelegaPrecompilatoCU AnnoImpostaPiuDue
      AutocertificazioneF6,
      CalcoloBonusIRPEF,
      RistampaLeStampate,
      FronteRetro,
      GuidaLettura,
      ArchiviaInZip,
      SalvaPreferenze,
      Fatture,
      LetteraNovita,
      isLoadingInternal,
      stampaAbilitata,
    } = this.state;

    const annoImpostaPiuUno = parseInt(annoSelezionato, 10);
    const annoImpostaPiuDue = parseInt(annoSelezionato, 10) + 1;

    return (
      <Modal show={showModal} onClose={this.annulla} loading={isLoadingInternal || isLoadingModale} className="printerDialog" style={{ width: '1000px' }}>
        <Modal.Header>Opzioni di stampa</Modal.Header>
        <Modal.Body>
          <Form stato={this.state} onChange={this.updateForm} ref={r => this.form = r}>
            <Grid fluid >
              <Grid.Row>
                <div className="printerWarningDiv">
                  {tabTutte
                    && (
                      <Panel info>
                        <div>
                          La selezione contiene sia stampe di prova che stampe ufficiali.
                        </div>
                      </Panel>
                    )}
                </div>
              </Grid.Row>
              <Grid.Row className="mb-8">
                <Grid.Col md="4">
                  <label><Checkbox checked={StampaDichiarazione} onChange={() => this.setCheckBoxState('StampaDichiarazione')} />Stampa mod. 730/{annoSelezionato} {stampaProva ? ' di prova' : ''}</label>
                </Grid.Col>
                <Grid.Col md="4">
                  <label><Checkbox checked={AutocertificazioneGenerica} onChange={() => this.setCheckBoxState('AutocertificazioneGenerica')} /> Autocertificazione generica</label>
                </Grid.Col>
                <Grid.Col md="4">
                  <label><Checkbox checked={FascicoloContribuente} onChange={() => this.clickFascicoloContribuente()} /> Fascicolo contribuente</label>
                </Grid.Col>
              </Grid.Row>
              <Grid.Row className="mb-8">
                <Grid.Col md="4">
                  <label><Checkbox checked={AutocertificazioneFamiglieNumerose} onChange={() => this.setCheckBoxState('AutocertificazioneFamiglieNumerose')} /> Autocertificazione famiglie numerose</label>
                </Grid.Col>
                <Grid.Col md="4">
                  <label><Checkbox checked={DelegaUnica} onChange={() => this.setCheckBoxState('DelegaUnica')} /> Delega Precompilato - CU {annoImpostaPiuDue}</label>
                </Grid.Col>
                <Grid.Col md="4">
                  <label className={(!FascicoloContribuente ? 'form__label--disabled' : '')}><Checkbox checked={InformativaPrivacy} onChange={() => this.setCheckBoxState2('InformativaPrivacy')} disabled={!FascicoloContribuente} /> Informativa privacy</label>
                </Grid.Col>
              </Grid.Row>
              <Grid.Row className="mb-8">
                <Grid.Col md="4">
                  <label><Checkbox checked={AutocertificazioneFamiliari} onChange={() => this.setCheckBoxState('AutocertificazioneFamiliari')} /> Autocertificazione familiari a carico</label>
                </Grid.Col>
                <Grid.Col md="4">
                  <label><Checkbox checked={StampaF24} onChange={() => this.setCheckBoxState('StampaF24')} /> Stampa F24</label>
                </Grid.Col>
                <Grid.Col md="4">
                  <label className={(!FascicoloContribuente ? 'form__label--disabled' : '')}><Checkbox checked={Scelta582x1000} onChange={() => this.setCheckBoxState2('Scelta582x1000')} disabled={!FascicoloContribuente} /> Scelta 5-8-2 x 1000</label>
                </Grid.Col>
              </Grid.Row>
              <Grid.Row className="mb-8">
                <Grid.Col md="4">
                  <label><Checkbox checked={AutocertificazioneC4} onChange={() => this.setCheckBoxState('AutocertificazioneC4')} /> Autocertificazione C4</label>
                </Grid.Col>
                <Grid.Col md="4">
                  <label><Checkbox checked={RichiestaAccredito} onChange={() => this.setCheckBoxState('RichiestaAccredito')} /> Richiesta accredito</label>
                </Grid.Col>
                <Grid.Col md="4">
                  <label className={(!FascicoloContribuente ? 'form__label--disabled' : '')}><Checkbox checked={DocumentiDaConsegnare} onChange={() => this.setCheckBoxState2('DocumentiDaConsegnare')} disabled={!FascicoloContribuente} /> Elenco doc. consegnati</label>
                </Grid.Col>
              </Grid.Row>
              <Grid.Row className="mb-8">
                <Grid.Col md="4">
                  <label><Checkbox checked={AutocertificazioneOneri} onChange={() => this.setCheckBoxState('AutocertificazioneOneri')} /> Autocertificazioni quadro E, F e G</label>
                </Grid.Col>
                <Grid.Col md="4">
                  <label><Checkbox checked={PromemoriaConguagli} onChange={() => this.setCheckBoxState('PromemoriaConguagli')} /> Promemoria conguagli</label>
                </Grid.Col>
                <Grid.Col md="4">
                  <label><Checkbox checked={LetteraNovita} onChange={() => this.setCheckBoxState('LetteraNovita')} /> Lettera novità 730/2021</label>
                </Grid.Col>
              </Grid.Row>
              <Grid.Row className="mb-8">
                <Grid.Col md="4">
                  <label><Checkbox checked={AutocertificazioneF6} onChange={() => this.setCheckBoxState('AutocertificazioneF6')} /> Autocertificazione F6</label>
                </Grid.Col>
                <Grid.Col md="4">
                  <label><Checkbox checked={CalcoloBonusIRPEF} onChange={() => this.setCheckBoxState('CalcoloBonusIRPEF')} /> Calcolo bonus IRPEF</label>
                </Grid.Col>
                <Grid.Col md="4">
                  <label><Checkbox checked={Fatture} onChange={() => this.setCheckBoxState('Fatture')} /> Fatture</label>
                </Grid.Col>
              </Grid.Row>
              <Grid.Row>
                <div className="printerDialogbb" />
              </Grid.Row>
              <Grid.Row>
                <Grid.Col md="4">
                  <Grid.Row className="mb-8">
                    <Grid.Col md="12">
                      <label><Checkbox checked={FronteRetro} onChange={() => this.setCheckBoxState('FronteRetro')} /> Stampa fronte/retro</label>
                    </Grid.Col>
                  </Grid.Row>
                  <Grid.Row className="mb-8">
                    <Grid.Col md="12">
                      <label><Checkbox checked={RistampaLeStampate} onChange={() => this.setCheckBoxState('RistampaLeStampate')} /> Ristampa le già stampate</label>
                    </Grid.Col>
                  </Grid.Row>
                  <Grid.Row className="mb-8">
                    <Grid.Col md="12">
                      <label><Checkbox checked={GuidaLettura} onChange={() => this.setCheckBoxState('GuidaLettura')} /> Stampa guida lettura (solo prima copia)</label>
                    </Grid.Col>
                  </Grid.Row>
                </Grid.Col>
                <Grid.Col md="4">
                  <Grid.Row className="mb-8">
                    <Grid.Col md="5" className="input__mt-15">
                      <Input title="Numero copie"
                        name="NrCopie"
                        onKeyDown={this.copieKeyDown}
                        validations={[{
                          rule: 'Pattern',
                          pattern: new RegExp('^[0-9]*$'),
                          message: 'Indicare il numero di copie da stampare',
                        },
                        {
                          rule: 'required',
                          message: 'Indicare il numero di copie da stampare',
                        }]} className="w-120" />
                    </Grid.Col>
                  </Grid.Row>
                </Grid.Col>
                <Grid.Col md="4">
                  <Grid.Row className="mb-8">
                    <Grid.Col md="5" className="input__mt-15">
                      <label><Checkbox checked={ArchiviaInZip} onChange={() => this.setCheckBoxState('ArchiviaInZip')} /> Creazione pdf separati per ogni dichiarante</label>
                    </Grid.Col>
                  </Grid.Row>
                </Grid.Col>
              </Grid.Row>
              <Grid.Row>
                <div className="printerDialogbb" />
              </Grid.Row>
              <Grid.Row className="mb-8">
                <Grid.Col md="12">
                  <label><Checkbox checked={SalvaPreferenze} onChange={() => this.setCheckBoxState('SalvaPreferenze')} /> Ricorda le opzioni</label>
                </Grid.Col>
              </Grid.Row>
              <Grid.Row>
                {messaggioErrore && <Panel error>{messaggioErrore}</Panel>}
              </Grid.Row>
            </Grid>
          </Form>

        </Modal.Body>
        <Modal.Footer>
          <Button flat onClick={this.annulla}>Annulla</Button>
          <Button flat primary onClick={this.stampa} disabled={!stampaAbilitata}>Stampa</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

ModaleStampa.propTypes = {
  isLoadingModale: PropTypes.bool,
  messaggioErrore: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  nrDichiarazioniSelezionate: PropTypes.number.isRequired,
  nrDichiarazioniSelezionateNonStampate: PropTypes.number.isRequired,
  nrDichiarazioniSelezionateStampate: PropTypes.number.isRequired,
  onAnnulla: PropTypes.func.isRequired,
  onStampa: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  stampaProva: PropTypes.bool.isRequired,
  tabTutte: PropTypes.bool.isRequired,
  userId: PropTypes.string.isRequired,
  annoSelezionato: PropTypes.number.isRequired,
};


ModaleStampa.defaultProps = {
  isLoadingModale: false,
  messaggioErrore: '',
};

export default ModaleStampa;
